<template>
  <button
    :style="getStyle(copyStatus)"
    :class="style.copyButton"
    @click="copying()"
  >
    <img src="$images/copy.svg" alt="" />
  </button>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./CopyButton.module.scss";
export default defineComponent({
  props: ["copy"],
  data() {
    return {
      style,
      copyStatus: false
    };
  },
  methods: {
    copying() {
      this.copyStatus = true;
      navigator.clipboard.writeText(this.copy);
      setTimeout(() => {
        this.copyStatus = false;
      }, 300);
    },
    getStyle(a: boolean) {
      if (a) {
        return {width: "45px", backgroundColor: "#7ee868"};
      }
      return {};
    }
  }
});
</script>
